import { Tooltip } from "@redelair-sa/intiza-ui";
import { formatAgendaDateTime } from "../utils/agendaFormat";

interface AgendaLastManagementProps {
  ultimaGestion: string | null;
  /** Relative text already formatted ("hace 15 días", "Última gestión: ayer"). */
  text: string;
}

/** Relative last activity; hovering shows the exact date and time. */
const AgendaLastManagement = ({
  ultimaGestion,
  text
}: AgendaLastManagementProps) =>
  ultimaGestion ? (
    <Tooltip content={formatAgendaDateTime(ultimaGestion)}>
      <span>{text}</span>
    </Tooltip>
  ) : (
    <span>{text}</span>
  );

export default AgendaLastManagement;
